exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".preview[data-v-cf92e81a]{border:1px solid lightgrey;border-radius:5px;padding:10px}#image-preview[data-v-cf92e81a]{max-width:100%}\n", ""]);

